import antiTheft from './js/antiTheft';
export default antiTheft;



// WEBPACK FOOTER //
// ./components/f.component.video.auth/app/index.js